import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { Button } from './Button';
const items = ['Devocional completo "Fui Llamada Para Este Momento" (12 días)', '12 reflexiones profundas con preguntas de aplicación personal', '12 declaraciones de fe para hablar sobre tu vida', '12 oraciones activadoras', 'Espacio de escritura y registro de tu proceso', 'Acceso a la comunidad de mujeres en propósito'];
export function OfferStack() {
  return <section className="py-8 px-5" id="offer" data-id="element-225">
      <div className="max-w-lg mx-auto" data-id="element-226">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6" data-id="element-227">
          <h2 className="font-serif text-2xl text-cream-100 mb-3" data-id="element-228">
            Tu inversión en este momento
          </h2>
          <p className="text-[14px] text-cream-300/80 font-light leading-relaxed mb-2" data-id="element-229">
            Podrías pasar otros 12 meses sintiéndote perdida. Podrías seguir
            esperando una señal más clara. Podrías seguir leyendo devocionales
            que no transforman nada.
          </p>
          <p className="text-[14px] text-gold-400 font-medium" data-id="element-230">
            O podrías invertir 12 días en descubrir que Dios lleva años
            preparándote para lo que viene.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-gradient-to-b from-navy-800 to-navy-900 border border-gold-500/30 rounded-sm p-4 sm:p-6 shadow-2xl shadow-gold-500/5" data-id="element-231">
          <div className="flex items-center justify-center gap-2 mb-5" data-id="element-232">
            <Sparkles className="text-gold-400" size={16} data-id="element-233" />
            <h3 className="font-sans font-semibold tracking-widest text-gold-400 uppercase text-xs" data-id="element-234">
              Lo que recibes hoy:
            </h3>
            <Sparkles className="text-gold-400" size={16} data-id="element-235" />
          </div>

          <ul className="space-y-2.5" data-id="element-236">
            {items.map((item, i) => <li key={i} className="flex items-start gap-2.5 pb-2.5 border-b border-gold-500/10 last:border-0 last:pb-0" data-id="element-237">
                <span className="text-gold-400 text-xs mt-0.5" data-id="element-238">✨</span>
                <span className="text-cream-200 text-[13.5px] leading-snug" data-id="element-239">
                  {item}
                </span>
                <span className="ml-auto text-[10px] font-medium text-gold-500/70 uppercase tracking-wider mt-0.5" data-id="element-240">
                  Incluido
                </span>
              </li>)}
          </ul>

          <div id="precio" className="mt-5 pt-5 border-t border-gold-500/30 text-center scroll-mt-24" data-id="element-241">
            <p className="text-xs uppercase tracking-[0.2em] text-gold-500 mb-3" data-id="element-242">
              Tu inversión hoy
            </p>
            <div className="flex items-center justify-center gap-3 mb-1" data-id="element-243">
              <div className="flex flex-col items-end" data-id="element-244">
                <span className="text-[10px] uppercase tracking-widest text-cream-300/60 leading-none" data-id="element-245">
                  Antes
                </span>
                <span className="font-serif text-2xl text-cream-300/60 line-through decoration-gold-500/60 decoration-1" data-id="element-246">
                  $19.99
                </span>
              </div>
              <div className="h-10 w-px bg-gold-500/30" data-id="element-247"></div>
              <div className="flex flex-col items-start" data-id="element-248">
                <span className="text-[10px] uppercase tracking-widest text-gold-500 leading-none" data-id="element-249">
                  Ahora
                </span>
                <div className="flex items-baseline gap-1" data-id="element-250">
                  <span className="font-serif text-5xl sm:text-6xl text-cream-100 font-semibold leading-none" data-id="element-251">
                    $12
                  </span>
                </div>
              </div>
            </div>
            <p className="text-xs text-cream-300/70 mt-2 italic mb-4" data-id="element-252">
              Pago único · Acceso inmediato
            </p>

            <Button fullWidth onClick={() => window.open('#', '_blank')} data-id="element-253">
              Comprar ahora — $12
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}